import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { ServerRecord } from '../data/inventoryData';
import { SiteMap } from '../utils/siteUtils';

interface KpiCardProps {
  value: number | string;
  label: string;
  color?: string;
}

function KpiCard({ value, label, color }: KpiCardProps) {
  return (
    <Paper
      variant="outlined"
      sx={{
        p: 1.5,
        flex: '1 1 120px',
        minWidth: 100,
        borderRadius: 2,
        borderColor: 'grayscale.400',
      }}
    >
      <Typography
        variant="h5"
        fontWeight={800}
        sx={{ color: color || 'primary.main' }}
      >
        {value}
      </Typography>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
    </Paper>
  );
}

interface Props {
  data: ServerRecord[];
  sites: SiteMap;
}

export default function InfraKpis({ data, sites }: Props) {
  const physical = data.filter((x) =>
    x.serverType.toLowerCase().includes('physical')
  ).length;
  const vms = data.filter(
    (x) => !x.serverType.toLowerCase().includes('physical')
  ).length;
  const gpu = data.filter((x) => Number(x.GPUCount) > 0).length;
  const withData = data.filter(
    (x) => x.CPU_Utilized !== 'NA' || x.Mem_Utilized !== 'NA'
  ).length;

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, mb: 2 }}>
      <KpiCard value={data.length} label="Total servers" color="primary.main" />
      <KpiCard
        value={Object.keys(sites).length}
        label="Sites"
        color="primary.main"
      />
      <KpiCard value={physical} label="Physical" />
      <KpiCard value={vms} label="Virtual machines" />
      <KpiCard value={gpu} label="GPU servers" color="success.main" />
      <KpiCard value={withData} label="With utilization data" />
    </Box>
  );
}
